import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/switch";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

export default function AdminBoard() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [defaultTimeLimit, setDefaultTimeLimit] = useState(300);
  const [useStandard, setUseStandard] = useState(true);

  useEffect(() => {
    api
      .get("/admin/settings/board")
      .then((r) => {
        setDefaultTimeLimit(r.data.default_time_limit ?? 300);
        setUseStandard(r.data.use_standard_layout !== false);
      })
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings/board", {
        default_time_limit: defaultTimeLimit,
        use_standard_layout: useStandard,
        layout: null,
      });
      toast.success("Configuration du plateau enregistrée");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="animate-spin text-[color:var(--primary)]" />
      </div>
    );
  }

  return (
    <div className="glass rounded-lg p-4 sm:p-6 max-w-xl">
      <h2 className="text-lg font-bold mb-4">Configuration du plateau</h2>
      <p className="text-sm text-[color:var(--text-secondary)] mb-6">
        Réglages globaux pour les nouvelles parties en ligne (grille 5×5 Perē Fa'anu'u).
      </p>

      <div className="space-y-6">
        <div>
          <Label htmlFor="time-limit">Temps par joueur (secondes)</Label>
          <Input
            id="time-limit"
            type="number"
            min={60}
            max={1800}
            className="mt-2 bg-[color:var(--surface)] border-[color:var(--border)]"
            value={defaultTimeLimit}
            onChange={(e) => setDefaultTimeLimit(parseInt(e.target.value, 10) || 300)}
          />
          <p className="text-xs text-[color:var(--text-secondary)] mt-1">Entre 60 s (1 min) et 1800 s (30 min)</p>
        </div>

        <div className="flex items-center justify-between gap-4 rounded-lg border border-[color:var(--border)] p-4">
          <div>
            <Label>Plateau standard</Label>
            <p className="text-xs text-[color:var(--text-secondary)] mt-1">
              10 pions par joueur, disposition officielle
            </p>
          </div>
          <Switch checked={useStandard} onCheckedChange={setUseStandard} />
        </div>

        <Button className="btn-gold w-full sm:w-auto" onClick={save} disabled={saving}>
          {saving ? <Loader2 className="animate-spin mr-2" size={16} /> : <Save className="mr-2" size={16} />}
          Enregistrer
        </Button>
      </div>
    </div>
  );
}
